<template>
  <v-container class="no-margins">
    <v-form ref="form" v-model="valid" lazy-validation>
      <h1>{{ $t('application.review.title') }}</h1>
      <p>
        {{ $t('application.review.info') }}
        (
        <v-icon x-small>$sl-navigate-left</v-icon>
        )
        {{ $t('application.review.info2') }}
      </p>
      <div class="title-icon hover">
        <h4>{{ $t('application.review.adress') }}</h4>
        <v-icon @click.stop="$emit('goToStep', '2')">$sl-navigate-left</v-icon>
      </div>

      <div class="overline">{{ $t('fields.firstName') }}</div>
      <p>{{ application.firstName }}</p>

      <div class="overline">{{ $t('fields.lastName') }}</div>
      <p>{{ application.lastName }}</p>

      <div class="overline">{{ $t('fields.address') }}</div>
      <p>{{ application.address1 }}</p>
      <p v-if="application.address2">{{ application.address2 }}</p>

      <v-row>
        <v-col cols="4 py-0">
          <div class="overline">{{ $t('fields.zip') }}</div>
          <p>{{ application.zip | formatZip }}</p>
        </v-col>
        <v-col cols="8 py-0">
          <div class="overline">{{ $t('fields.city') }}</div>
          <p>{{ application.city }}</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12 py-0">
          <div class="overline">{{ $t('fields.country') }}</div>
          <p>{{ getCountry() }}</p>
        </v-col>
      </v-row>

      <h4>{{ $t('application.review.periodTtitle') }}</h4>
      <!--application profession  -->
      <div class="title-icon hover top mt-n4">
        <div>
          <div class="overline">{{ $t('fields.profession') }}</div>
          <p>{{ this.professionNm }}</p>
        </div>
        <v-icon v-if="!application.isCompanyApplication" @click.stop="$emit('goToStep', '3')">$sl-navigate-left</v-icon>
      </div>

      <!--application professionOrientations  -->
      <div
        class="title-icon hover top mb-8"
        v-if="application && application.professionOrientations && application.professionOrientations.length > 0"
      >
        <div>
          <div class="overline">{{ $t('fields.profession-orientation') }}</div>
          <div v-for="item in application.professionOrientations" :key="item.id">
            <p class="mb-0">{{ item.professionMachineOrientation.machine.name }}</p>
          </div>
        </div>
        <v-icon v-if="application && !application.isCompanyApplication" @click.stop="$emit('goToStep', '4')"
          >$sl-navigate-left</v-icon
        >
      </div>

      <!--application Company  -->
      <div class="title-icon top" v-if="companyNm">
        <div>
          <div class="overline">{{ $t('fields.company') }}</div>
          <p>{{ companyNm + orgno }}</p>
          <MessageBox class="mb-10" type="info" v-if="!isApprovedCompany">
            <p v-html="$t('application.company.missinginfo1')"></p>
          </MessageBox>
        </div>
        <v-icon v-if="application && !application.isCompanyApplication" @click.stop="$emit('goToStep', '7')"
          >$sl-navigate-left</v-icon
        >
      </div>

      <div v-if="workplace && workplace.postalAddress1 && workplace.postalCity">
        <div class="overline">{{ $t('fields.workplace') }}</div>
        <p>{{ workplace.postalAddress1 + ', ' + workplace.postalCity }}</p>
      </div>

      <template v-if="department && department.name">
        <div class="title-icon hover top" v-if="companyNm">
          <div v-if="department && department.name">
            <div class="overline">{{ $t('fields.department') }}</div>
            <p>{{ department.name }}</p>
          </div>
          <v-icon v-if="application && !application.isCompanyApplication" @click.stop="$emit('goToStep', '8')"
            >$sl-navigate-left</v-icon
          >
        </div>
      </template>
      <div v-if="instructorNm != ''">
        <div class="overline">{{ $t('fields.instructor') }}</div>
        <p>{{ instructorNm }}</p>
      </div>

      <div v-if="employedType != ''">
        <div class="overline">{{ $t('fields.emloymentform') }}</div>
        <p>{{ employedType }}</p>
      </div>

      <div v-if="employmentDate != ''">
        <div class="overline">{{ $t('fields.start-date') }}</div>
        <p>{{ employmentDate }}</p>
      </div>

      <div
        v-if="
          selectedApplication &&
          selectedApplication.applicationCourses &&
          find(selectedApplication.applicationCourses, ['approved', null])
        "
      >
        <h4 class="mt-3">{{ $t('application.review.education-demand') }}</h4>
        <MessageBox class="mb-10" type="info">
          <p>
            {{ $t('application.review.education-demand-info') }} {{ this.professionNm }}.
            {{ $t('application.review.education-demand-info1') }}
          </p>
          <p>
            <a :href="links.main.bynMoreInfo" target="_blank">{{ $t('application.review.messageLink') }}</a>
          </p>
        </MessageBox>
      </div>
      <!-- Application message -->
      <div v-if="application && application.notification && application.notification.notification.length > 0">
        <div class="title-icon">
          <h4>{{ $t('application.review.messageTitle') }}</h4>
          <v-icon @click.stop="$emit('goToStep', '9')">$sl-navigate-left</v-icon>
        </div>
        <p>{{ $t('application.message.info-message') }}</p>
        <v-textarea
          outlined
          v-model="application.notification.notification"
          :value="application.notification.notification"
        ></v-textarea>
      </div>

      <!-- Accept and continue -->
      <h4 class="mt-2">{{ $t('application.review.CheckBoxTitle') }}</h4>
      <div class="d-flex mt-5 mb-12">
        <v-checkbox class="mt-0 marked-blue label-top" v-model="application.sign" :label="$t('application.review.acceptCheckBox')"></v-checkbox>         
      </div>
    </v-form>

    <NextButton :isDisabled="isDraft || !application.sign" @click="nextStep" :isEnterSubmit="false">{{
      $t('labels.sign-application')
    }}</NextButton>

    <BottomNav @clicked="$emit('goToStep', '-1')" />
  </v-container>
</template>

<script>
// Entryform for unknown user to become a apprentice
import API from '@/services/api.js'
//import AddressBox from '@/components/AddressBox'
import NextButton from '@/components/Common/NextButton'
import BottomNav from '@/components/Application/BottomNav'
import {mapActions, mapGetters} from 'vuex'
import pick from 'lodash/pick'
import find from 'lodash/find'
import sortBy from 'lodash/sortBy'
import {RulesMixin, CompanyRoles} from '@/components/mixins'
import MessageBox from '@/components/Common/MessageBox'
import get from 'lodash/get'
import { union, uniqBy } from 'lodash'
const SugarDate = require('sugar/date')

// @group Application-Apprentice
// ApplicationReview component
export default {
  name: 'ApplicationReview',

  mixins: [RulesMixin, CompanyRoles],
  components: {
    MessageBox,
    BottomNav,
    NextButton
  },

  data: () => ({
    links: require('../../../lib/external-links.json'),
    notification: '',
    updated: '',    
    application: null,
    countries: [],
    courses: {},
    chkGrade: [],
    txtGrade: [],
    professionNm: '',
    companyNm: '',
    isApprovedCompany: false,
    employedType: '',
    workplace: {},
    department: {},
    instructorNm: '',
    orgno: '',
    employmentDate: '',
    notification: '',
    lastCompanyId: 0,
    fields: [
      'id',
      'firstName',
      'lastName',
      'address1',
      'address2',
      'personalNumber',
      'zip',
      'city',
      'country',
      'step',
      'notification',
      'professionId',
      'companyId',
      'sign',
      'email',
      'isCompanyApplication',
      'mobilephone',
      'professionOrientations',
      'highSchoolReform'
    ],
    valid: true,
    states: []
  }),

  created() {
    this.initApplication()
    //this.fetchCourses();
  },

  watch: {
    /**
     * @vuese
     * Used to watch the selectedApplication and call initApplication and fetch professions
     * @arg called with no argument
     */
    selectedApplication: {
      handler: function () {
        this.initApplication()
        // this.fetchCourses();
      },
      deep: true
    }
  },

  computed: {
    ...mapGetters('application', ['currentStep', 'selectedApplication']),
    ...mapGetters('currentuser', ['currentUser']),
    ...mapGetters('basic', [
      'basicStates',
      'apprenticeDraftStateId',
      'companyDraftStateId',
      'getProfessionById',
      'basicProfessions',
      'getEmploymentTypeNameById'
    ]),
    ...mapGetters('app', ['locale']),

    /**
     * @vuese
     * Used to return a boolean if the application is draft
     */
    isDraft() {
      return (
        this.application.stateId &&
        (this.application.stateId === companyDraftStateId || this.application.stateId === apprenticeDraftStateId)
      )
    }
  },

  methods: {
    ...mapActions('application', ['updateSelectedApplication']),

    sortBy: sortBy,
    find: find,
    /**
     * @vuese
     * Used to Initialize application with  selected values from all the previous steps
     */
    initApplication() {
      //- Initialize application
      if (this.selectedApplication && this.selectedApplication.id) {
        if (this.selectedApplication.workplace) {
          this.workplace = this.selectedApplication.workplace
        }
        if (this.selectedApplication.department) {
          this.department = this.selectedApplication.department
        }
        if (this.selectedApplication.employmentTypeId) {
          this.employedType = this.getEmploymentTypeNameById(Number(this.selectedApplication.employmentTypeId))
        } else {
          this.employedType = ''
        }

        if (this.selectedApplication.employmentDate) {
          this.employmentDate = SugarDate.Date(this.selectedApplication.employmentDate).format('{yyyy}-{MM}-{dd}').raw
        } else {
          this.employedType = ''
        }

        this.application = pick(this.selectedApplication, this.fields)

        if (this.selectedApplication.professionId) {
          this.professionNm = this.professionName(this.selectedApplication.professionId)
        }

        if (
          this.selectedApplication.instructor &&
          this.selectedApplication.instructor.employed &&
          this.selectedApplication.instructor.employed.firstName &&
          this.selectedApplication.instructor.employed.lastName
        ) {
          this.instructorNm =
            this.selectedApplication.instructor.employed.firstName +
            ' ' +
            this.selectedApplication.instructor.employed.lastName
        } else {
          this.instructorNm = ''
        }

        if (this.selectedApplication.companyId && this.lastCompanyId != this.selectedApplication.companyId) {
          this.lastCompanyId = this.selectedApplication.companyId

          this.getCompanyName(this.selectedApplication.companyId)
        }
        
      } else {
        this.application = Object.fromEntries(
          this.fields.map(f => {
            return [f, null]
          })
        )
      }

      this.application.step = this.currentStep
      this.states = this.basicStates

      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }

      /*  if (this.$refs.addressbox && this.$refs.addressbox.$refs && this.$refs.addressbox.$refs.form) {
        this.$refs.addressbox.$refs.form.resetValidation()
      } */
    },
    /**
     * @vuese
     * Used to get Sweden as a default country name
     */
    getCountry() {
      const countries = require('i18n-iso-countries')
      countries.registerLocale(require('i18n-iso-countries/langs/' + this.locale + '.json'))

      //let c = countries.find(x => x.key == this.application.country)
      if (this.application.country && this.application.country != '') {
        return countries.getName('SE', this.locale)
      }
      return ''    
    },    
    /**
     * @vuese
     * Used to fetch profession name based on profession id
     * @arg The argument is an integer value representing profession id
     */
    professionName(id) {
      const p = this.basicProfessions.find(x => x.id === Number(id))
      return p ? p.name : ''
    },
    /**
     * @vuese
     * Used to fetch company name and company org number based on company id
     * @arg The argument is an integer value representing company id
     */
    getCompanyName(id) {
      API.getCompany(id)
        .then(res => {
          this.companyNm = res.data.name
          this.isApprovedCompany = res.data.isApproved
          if (res.data.organizationalNumber) {
            this.orgno =
              ' (' +
              res.data.organizationalNumber.substring(0, 6) +
              '-' +
              res.data.organizationalNumber.substring(6, 10) +
              ')'
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    /**
     * @vuese
     * Used to go to the next step if form is valid and update the application with new criterias
     * @arg The argument is an integer value representing company id
     */
    nextStep() {

      this.application.email = this.application.email || this.currentUser.email
      this.application.mobilephone = this.application.mobilephone || this.currentUser.mobilephone

      if((!this.application.email || !this.application.mobilephone))
      {
        this.$events.fire('showError', this.$t('errors.email-phone-missing'))
        return
      }

      this.application.transferOldProfession = this.selectedApplication.transferOldProfession
      const education = this.currentUser.educations.find(o => o.professionId === this.application?.professionId)
      let oldApplicationData = {}
      let educationId = null

      if( this.application?.transferOldProfession ) {
        if ( education ) {
          oldApplicationData = pick(education?.application, ['allCoursesApproved', 'applicationCourses', 'applicationDocuments'])
          educationId = education.id
        }

        //- Merge old application data to new application with same profession
        this.application = { ...this.application, ...oldApplicationData, educationId }
      }

      API.updateApplication(this.application.id, {
        data: this.application
      })
        .then(() => {
          /**
           * @vuese
           * Used to store new criterias in vuex store
           * @arg The argument is the application with all the fields fill in
           */
          this.updateSelectedApplication(this.application)
          // Fire +1
          // @arg The argument is a integer representing (move one step forward)
          this.$emit('goToStep', '+1')
        })
        .catch(error => {
          this.$events.fire('showError', this.$t('errors.save-failure'))
        })
    }
  }
}
</script>

<style scoped></style>
